export default "__VITE_ASSET__CDiS9iam__"